import {
  INDIAN_STATES,
  CONTACT_STAGES,
  Verve_REQUIREMENTS,
  STATUS_COLORS,
  ADMIN_TABLE_HEADERS,
  TELECALLER_TABLE_HEADERS,
  INITIAL_CUSTOMER_FORM
} from "@/constants/globalConstants";
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */

export const REFERENCE_SOURCES = [
  "Walk In",
  "Marketing",
  "Direct",
  "Facebook",
  "Instagram",
  "Youtube",
  "Whatsapp",
  "Website",
  "Just Dail",
  "Indiamart",
  "Google",
  "Call Center",
  "Sign Board",
  "Interior Designer",
  "Architect",
  "Friends",
  "News Paper",
  "Others",
];

export const PROPERTY_REQUIREMENTS_LEFT = [
  "Wardrobes",
  "Semi Modular Kitchen",
  "Interiors"
];

export const PROPERTY_REQUIREMENTS_RIGHT = [
  "Fully Modular Kitchen",
  "Appliances",
  "Designing & Estimate of Modular Kitchen"
];

export const PROPERTY_REQUIREMENTS_ALL = [
  ...PROPERTY_REQUIREMENTS_LEFT,
  ...PROPERTY_REQUIREMENTS_RIGHT
];

export const getVisibleContactStagesForRole = (stages, user) => {
  if (!stages) return [];
  const role = (user?.role || "").toLowerCase().trim();
  if (["client_coordinator", "client coordinator"].includes(role)) {
    const allowedKeys = [
      "new",
      "assigned",
      "not_reachable",
      "not_answered",
      "not_interested",
      "contact_later",
      "duplicate",
      "interested",
      "appointment_scheduled",
      "drop"
    ];
    return stages.filter((s) => allowedKeys.includes(s.key));
  }
  if (["field_marketing", "field marketing"].includes(role)) {
    const allowedKeys = ["converted", "appointment_scheduled", "site_visit", "drop"];
    return stages.filter((s) => allowedKeys.includes(s.key));
  }
  return stages;
};

export {
  INDIAN_STATES,
  CONTACT_STAGES,
  Verve_REQUIREMENTS,
  STATUS_COLORS,
  ADMIN_TABLE_HEADERS,
  TELECALLER_TABLE_HEADERS,
  INITIAL_CUSTOMER_FORM
};

